import { MdClose } from 'react-icons/md'

import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const TitleModal = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 20px;
  font-weight: 700;
  padding-bottom: 20px;
  color: ${colors.blue};
`

export const SubTitleModal = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.blue};
  font-family: Roboto;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-align: center;
  padding-bottom: 30px;
`

export const StyledCheck = styled(MdClose)`
  color: ${colors.blue};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border: 3px solid ${colors.blue};
  border-radius: 50%;
`
